import React, {useState} from "react";
import {css, Theme} from "@emotion/react";

import {SystemModal} from "@pg-design/modal-module";

import {IAskForAllModalViewData} from "./ask_for_all_modal_types";
import {AskForAllModalAllSentConfirmation} from "./AskForAllModalAllSentConfirmation";
import {AskForAllModalListWithForm} from "./AskForAllModalListWithForm";
import {AskForAllModalRejectedInfo} from "./AskForAllModalRejectedInfo";

interface IProps {
    isOpened: boolean;
    closeModal: () => void;
}

export const AskForAllModal = (props: IProps) => {
    const {isOpened, closeModal} = props;
    const [confirmationViewData, setConfirmationViewData] = useState<IAskForAllModalViewData>({type: "listWithForm"});

    return (
        <SystemModal isOpen={isOpened} onModalClose={closeModal} css={askForAllModal}>
            {confirmationViewData.type === "listWithForm" && (
                <AskForAllModalListWithForm
                    setModalView={(viewData) => {
                        setConfirmationViewData(viewData);
                    }}
                />
            )}
            {confirmationViewData.type === "justConfirm" && <AskForAllModalAllSentConfirmation />}
            {confirmationViewData.type === "informAboutRejected" && <AskForAllModalRejectedInfo confirmationList={confirmationViewData} />}
        </SystemModal>
    );
};

const askForAllModal = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.sm}) {
        max-width: 892px;
    }
`;
import React, {useState} from "react";
import {css, Theme} from "@emotion/react";

import {SystemModal} from "@pg-design/modal-module";

import {IAskForAllModalViewData} from "./ask_for_all_modal_types";
import {AskForAllModalAllSentConfirmation} from "./AskForAllModalAllSentConfirmation";
import {AskForAllModalListWithForm} from "./AskForAllModalListWithForm";
import {AskForAllModalRejectedInfo} from "./AskForAllModalRejectedInfo";

interface IProps {
    isOpened: boolean;
    closeModal: () => void;
}

export const AskForAllModal = (props: IProps) => {
    const {isOpened, closeModal} = props;
    const [confirmationViewData, setConfirmationViewData] = useState<IAskForAllModalViewData>({type: "listWithForm"});

    return (
        <SystemModal isOpen={isOpened} onModalClose={closeModal} css={askForAllModal}>
            {confirmationViewData.type === "listWithForm" && (
                <AskForAllModalListWithForm
                    setModalView={(viewData) => {
                        setConfirmationViewData(viewData);
                    }}
                />
            )}
            {confirmationViewData.type === "justConfirm" && <AskForAllModalAllSentConfirmation />}
            {confirmationViewData.type === "informAboutRejected" && <AskForAllModalRejectedInfo confirmationList={confirmationViewData} />}
        </SystemModal>
    );
};

const askForAllModal = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.sm}) {
        max-width: 892px;
    }
`;
